import BasicInitializationService from "../../services/initialization/basicInitializationService";
import makeWidgetFor from "../../viewModels/makeWidgetFor";
import ChargeManagementViewModel from "../../viewModels/chargeManagement/chargeManagementViewModel";
import { registerWidget } from "../widget";

const ChargeManagementWidgetIdentifier = "edaz-charge-management";

registerWidget({
  component: makeWidgetFor(ChargeManagementWidgetIdentifier, [ChargeManagementViewModel], BasicInitializationService),
  configuration: {
    tagname: ChargeManagementWidgetIdentifier,
  },
});
